const module = { name: 'shared/global/Fandango.i18n', exports: {} }; const exports = module.exports;



import { Fandango_xhr as xhr } from 'require-core';



import { fd_url_manager as link } from 'require-core';



const XHR_TIMEOUT = 10000


const Languages = {
    ENGLISH: 'en',
    SPANISH: 'es'
}


const ModelAvailability = {
    AVAILABLE: 'available',
    DOWNLOADABLE: 'downloadable',
    UNAVAILABLE: 'unavailable',
}


const State = {
    NOT_STARTED: 'not_started',
    INITIALIZING: 'initializing',
    READY: 'ready',
    ERROR: 'error'
}


const Errors = {
    INIT_FIRST_ERROR: 'init() must be called before translate().',
    NO_LANGUAGE_ERROR: 'Provide both Source and Target languages.',
    DOWNLOAD_ERROR: 'Error downloading translator model.',
    TIMEOUT_ERROR: 'Translator creation timed out.',
    LANGUAGE_PAIR_NOT_SUPPORTED: (source, target) => `Requested language pair not available. {source: ${source}, target:${target}}`,
    INIT_TRANSLATOR_ERROR: 'Error initializing translator.',
    CLOUD_REQUEST_ERROR: 'Cloud translation request failed.',
    CLOUD_DATA_ERROR: 'Cloud translation returned no data.',
    UNKNOWN_ERROR: 'An unknown error occurred.',
}


const loadingOverlay = setupLoadingOverlay()


let translator


let error


let translations = []


let useTranslatorApi = false


let translatorApiState = State.NOT_STARTED


let isTranslating = false


let sourceLanguage


let targetLanguage


const useStreaming = false
async function isModelAvailable() {
    const modelAvailability = await Translator.availability({
        sourceLanguage,
        targetLanguage,
    });
    return modelAvailability !== ModelAvailability.UNAVAILABLE;
}
function setupLoadingOverlay() {
    const overlay = document.createElement('div');
    overlay.id = 'translator-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      color: white;
      font-size: 18px;
    `;
    overlay.innerHTML = 'Loading translator...';
    return overlay;
}
async function initializeTranslator() {
    translatorApiState = State.INITIALIZING;
    let shouldShowOverlay = true;
    const overlayTimeout = setTimeout(() => {
        if (shouldShowOverlay) {
            document.body.appendChild(loadingOverlay);
        }
    }, 100);
    console.log(`Initializing translator with {source: ${sourceLanguage}, target: ${targetLanguage}}`);
    try {
        await Promise.race([
            new Promise((resolve, reject) => {
                Translator.create({
                    sourceLanguage,
                    targetLanguage,
                    monitor(m) {
                        m.addEventListener('downloadprogress', (e) => {
                            console.log(`Downloaded ${e.loaded * 100}%`);
                            if (e.loaded === 1) {
                                resolve();
                            }
                        });
                    },
                }).then((translatorInstance) => {
                    translator = translatorInstance;
                    translatorApiState = State.READY;
                }).catch((err) => {
                    reject(err || Errors.DOWNLOAD_ERROR);
                });
            }),
            new Promise((_, reject) => setTimeout(() => reject(Errors.TIMEOUT_ERROR), 10000))
        ]);
    }
    catch (err) {
        reportError(err);
    }
    finally {
        const overlayElement = document.getElementById('translator-overlay');
        if (overlayElement) {
            overlayElement.remove();
        }
        else {
            shouldShowOverlay = false;
            clearTimeout(overlayTimeout);
        }
    }
}
async function waitForStateChange() {
    return new Promise((resolve) => {
        const checkState = () => {
            if (translatorApiState !== State.INITIALIZING) {
                resolve();
            }
            else {
                setTimeout(checkState, 50);
            }
        };
        checkState();
    });
}
function reportError(err) {
    translatorApiState = State.ERROR;
    error = err;
    console.error(error);
}
async function translateWithApi() {
    switch (translatorApiState) {
        case State.INITIALIZING:
            await waitForStateChange();
            return translateWithApi();
        case State.ERROR:
            return { success: false, message: error };
        case State.READY: {
            const elementsToTranslate = document.querySelectorAll('[data-translate]');
            if (!elementsToTranslate.length) {
                return { success: true, message: null };
            }
            if (isTranslating) {
                if (useStreaming) {
                    return { success: true, message: null };
                }
                else {
                    const translationPromises = [...elementsToTranslate].map(async (element) => {
                        const existingTranslation = translations.find(t => t.id === element.id);
                        if (existingTranslation) {
                            element.innerText = existingTranslation.translatedText;
                            return existingTranslation;
                        }
                        else {
                            const translatedText = await translator.translate(element.innerText);
                            const translation = { id: element.id, originalText: element.innerText, translatedText };
                            element.innerText = translatedText;
                            return translation;
                        }
                    });
                    const completedTranslations = await Promise.all(translationPromises);
                    translations.push(...completedTranslations);
                    return { success: true, message: null };
                }
            }
            else {
                elementsToTranslate.forEach((element) => {
                    const translation = translations.find(t => t.id === element.id);
                    element.innerText = translation ? translation.originalText : element.innerText;
                });
                return { success: true, message: null };
            }
        }
        default:
            reportError(Errors.UNKNOWN_ERROR);
            return { success: false, message: error };
    }
}
async function translateWithCloud() {
    const elementsToTranslate = document.querySelectorAll('[data-translate]');
    if (!elementsToTranslate.length) {
        return { success: true, message: null };
    }
    if (isTranslating) {
        const untranslatedElements = [...elementsToTranslate].filter((element) => {
            const translatedElement = translations.find(t => t.id === element.id);
            if (translatedElement) {
                element.innerText = translatedElement.translatedText;
                return false;
            }
            else {
                return true;
            }
        });
        const translationObjects = untranslatedElements.map(element => ({
            id: element.id,
            originalText: element.innerText
        }));
        let cloudResponse;
        if (translationObjects.length > 0) {
            await xhr.ajax({
                method: 'POST',
                url: link.napiTranslate(),
                timeout: XHR_TIMEOUT,
                data: {
                    translationObjects: JSON.stringify(translationObjects),
                    sourceLanguage,
                    targetLanguage,
                    url: window.location.href,
                },
                success(data) {
                    if (data && Array.isArray(data)) {
                        data.forEach((translatedObj) => {
                            const element = document.getElementById(translatedObj.id);
                            if (element) {
                                element.innerText = translatedObj.translatedText;
                            }
                        });
                        translations.push(...data);
                        cloudResponse = { success: true, message: null };
                    }
                    else {
                        cloudResponse = { success: false, message: Errors.CLOUD_DATA_ERROR };
                    }
                },
                error(error) {
                    reportError(error);
                    cloudResponse = { success: false, message: error || Errors.CLOUD_REQUEST_ERROR };
                }
            });
        }
        return cloudResponse ?? { success: true, message: null };
    }
    else {
        elementsToTranslate.forEach((element) => {
            const translation = translations.find(t => t.id === element.id);
            element.innerText = translation ? translation.originalText : element.innerText;
        });
        return { success: true, message: null };
    }
}
async function translate() {
    if (!sourceLanguage || !targetLanguage) {
        reportError(Errors.INIT_FIRST_ERROR);
        return { success: false, message: error };
    }
    if (useTranslatorApi) {
        if (await isModelAvailable()) {
            if (translator && translatorApiState === State.READY) {
                isTranslating = !isTranslating;
                return translateWithApi();
            }
            else {
                await initializeTranslator();
                isTranslating = !isTranslating;
                return translateWithApi();
            }
        }
        else {
            reportError(Errors.LANGUAGE_PAIR_NOT_SUPPORTED(sourceLanguage, targetLanguage));
            return { success: false, message: error };
        }
    }
    else {
        isTranslating = !isTranslating;
        return translateWithCloud();
    }
}
function init(source, target) {
    if (source && target) {
        useTranslatorApi = false;
        translatorApiState = State.NOT_STARTED;
        translator = undefined;
        error = undefined;
        isTranslating = false;
        translations = [];
        sourceLanguage = source;
        targetLanguage = target;
        if ('Translator' in self) {
            useTranslatorApi = true;
        }
    }
    else {
        reportError(Errors.NO_LANGUAGE_ERROR);
    }
}
module.exports = {
    init,
    translate,
    Languages,
    getIsTranslating: () => isTranslating
};
export default module.exports;